import template from './employee_resign.html';
import tr from '../../lib/default-translator.js';

class EmployeeResignViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.end_date = ko.observable();
		this.comment = ko.observable();
		this.process_id = ko.observable();
		this.resign_types = ko.observableArray();
		this.unassign_managers = ko.observable(true); 
		this.selected_resign_type = ko.observable();
	};

	close()
	{
		this.dialog.close();
	}

	async resign_employee ()
	{
		//Validation on resign date
		if (this.end_date() == null || this.end_date() == undefined)
		{
			Grape.alerts.alert({type: 'error', message: tr('Please enter a resignation date.'), title: tr('Error')});
			return;
		}

		let obj = {
			param: {
				employee_id: this.dialog.bindings.employee_id,
				end_date: this.end_date(),
				comment: this.comment(),
				resign_type: this.selected_resign_type(),
				unassign_managers: this.unassign_managers()
			}
		};

		let today = new Date();
		let dd = String(today.getDate()).padStart(2, '0');
		let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
		let yyyy = today.getFullYear();

		let formatedtoday = yyyy + '-' + mm + '-' + dd;

		if (this.end_date() > formatedtoday)
		{
			await Grape.alerts.alert({type: 'warning', message: tr('Please note that the employee will be active until resignation date: .' + this.end_date() , 'Please note that the employee will be active until resignation date: ' + this.end_date()), title: tr('Warning')});
			let d = new Date(this.end_date() + ' 00:00');
			obj.time_sched = d.toISOString();


			let result = await Grape.fetches.postJSON('/api/bgworker/' + this.process_id() + '/schedule', obj);
			
			if (result.status == 'ERROR')
				Grape.alerts.apiError(d);
			else
			{
				await Grape.alerts.alert({type: 'success', title: tr('Schedule created'), message: tr('Schedule created successfully')});
				this.dialog.close();
			}
			this.dialog.close();
		}
		else
		{
			let obj_resign = {
				employee_id: this.dialog.bindings.employee_id,
				end_date: this.end_date(),
				comment: this.comment(),
				resign_type: this.selected_resign_type(),
				unassign_managers: this.unassign_managers()
			};

				let res = await Grape.fetches.postJSON('/employee/resign', obj_resign);
				
				if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success', message: tr('Successfully resigned employee.'), title: tr('Success')});
					this.dialog.close();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else if (res.error)
					Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
				else
					Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	};
};

class EmployeeResignPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeResignViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'resign_types',
			limit: 1000000,
			sortfield: 'sort_order',
			sortorder: 'asc'
		});
		if (res.status !== 'ERROR')
			this.viewModel.resign_types(res.records);

		let options = {
			table: 'process',
			schema: 'bgworker',
			limit: 10000000,
			filter:  [{ value: 'resign_employee_scheduled', op: '=', field: 'process_name' }]
		}
		this.viewModel.selected_resign_type('Resign')

		let result = await Grape.fetches.getJSON('/api/record', options);
		this.viewModel.process_id(result.records[0].process_id);
	}
};

export default {
	name: 'EmployeeResign',
	dialog_class: EmployeeResignPage,
	template: template,
	template_filename: 'translation/dialogs/employee_resign',
	provider: 'ps'
};
